angular.module('unergie.main')
.directive('salesTunnelConsentsV3', ($uibModal, $filter, MetaWatcher, ReferencesService, AuthService, ApiUser, DraftsBasic, BoFeaturesService, DataAccessSearch, ErrorCatcher, PrmUtilsService) =>
    ({
        restrict: 'E',
        scope: {
            draft: '=',
            consents: '=',
            subscriptions: '=',
            draftServices: '=',
            validated: '=',
            disableContractEdition: '=',
        },
        templateUrl: '/states/salesTunnelV3/component/salesTunnelConsentsV3.html',
        link($scope) {
            $scope.form = {
                consents: {},
                subscriptions: {},
            }

            // VALIDATORS
            const initComponentValidator = () => {
                MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                    isConsentsFilled(store) {
                        return _.every(store.consents, (consent) => !consent.id || consent.value != null)
                    },
                    isSubscriptionsFilled(store) {
                        return _.every(store.subscriptions, (subscription) => !subscription.id || subscription.value != null)
                    },
                })
            }

            $scope.$watch('consents', (values) => {
                $scope.form.consents = {}
                _.each(values, (v) => {
                    $scope.form.consents[v.id] = v.value
                })
            })

            $scope.checkAndSaveConsents = () => {
                if (_.every($scope.form.consents, (v) => v != null)) {
                    $scope.draftServices.updateConsents($scope.form.consents)
                }
            }

            $scope.$watch('subscriptions', (values) => {
                $scope.form.subscriptions = {}
                _.each(values, (v) => {
                    $scope.form.subscriptions[v.id] = v.value
                })
            })

            $scope.checkAndSaveSubscriptions = () => {
                if (_.every($scope.form.subscriptions, (v) => v != null)) {
                    $scope.draftServices.updateSubscriptions($scope.form.subscriptions)
                }
            }

            const activate = function () {
                initComponentValidator()
            }

            $scope.sendConsentsReminderEmail = () => $scope.draftServices.sendConsentsReminderEmail(!!$scope.draft.consents_reminder_sent_ts, false)

            activate()
        },
    })
)
